import AttributionChannelSelector from '../../EmailCapturePage/AttributionSourceSelector/AttributionChannelSelector'
import MixtilesDialog from '../../../components/MixtilesDialog/MixtilesDialog'
import * as S from './PostPurchaseAttribution.styles'
import { useTranslation } from 'react-i18next'
import TextButton, {
  VARIANTS as TEXT_BUTTON_VARIANTS,
} from 'mixtiles-web-common/ui/TextButton'

type Props = {
  show: boolean
  source: string
  onSubmit: ({
    channelName,
    subChannel,
  }: {
    channelName: string
    subChannel?: string
  }) => void
}

function PostPurchaseAttribution({ show, source, onSubmit }: Props) {
  const { t } = useTranslation()

  const handleSkipClick = () => {
    onSubmit({ channelName: 'Skip' })
  }

  const handleClick = ({
    channelName,
    subChannel,
  }: {
    channelName: string
    subChannel?: string
  }) => {
    onSubmit({ channelName, subChannel })
  }

  return (
    // @ts-ignore
    <MixtilesDialog open={show} fullScreen transition="noTransition">
      <S.Container
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        transition={{
          duration: 0.3,
          ease: 'easeOut',
          delay: 0.1,
        }}
      >
        <S.Title>{t('new_email_capture.attribution.help_us_improve')}</S.Title>
        <S.Subtitle>{t('new_email_capture.attribution.title')}</S.Subtitle>
        <AttributionChannelSelector onClick={handleClick} source={source} />
        <TextButton
          variant={TEXT_BUTTON_VARIANTS.underline}
          onClick={handleSkipClick}
          testId="post-purchase-attribution-skip-button"
        >
          {t('general.skip')}
        </TextButton>
      </S.Container>
    </MixtilesDialog>
  )
}

export default PostPurchaseAttribution
